import { render, staticRenderFns } from "./SubscriptionMobileHeaderActions.vue?vue&type=template&id=870fd1d2&scoped=true&"
import script from "./SubscriptionMobileHeaderActions.vue?vue&type=script&lang=js&"
export * from "./SubscriptionMobileHeaderActions.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionMobileHeaderActions.vue?vue&type=style&index=0&id=870fd1d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870fd1d2",
  null
  
)

export default component.exports